import "@hotwired/turbo-rails";
import "@/tom-select.js";
import * as bootstrap from "bootstrap";
import * as vue from "vue";
import * as semverParser from "semver-parser";
import { createApp } from "vue";
import DependencyTable from "../components/DependencyTable.vue";

window.bootstrap = bootstrap;
window.Vue = vue;
window.semverParser = semverParser;

let app = null;
let isMounting = false;

function getDataFromElement(element) {
  try {
    const dependenciesData = element.dataset.dependencies || "[]";
    const repositoriesData = element.dataset.repositories || "[]";
    const repositoryGroupsData = element.dataset.repositoryGroups || "[]";
    const availableBranchesData = element.dataset.availableBranches || "[]";
    const selectedBranchesByRepoData = element.dataset.selectedBranchesByRepo || "{}";
    const repositoryBranchesData = element.dataset.repositoryBranches || "{}";
    const selectedRepositoriesData = element.dataset.selectedRepositories || "[]";

    return {
      dependencies: JSON.parse(dependenciesData),
      repositories: JSON.parse(repositoriesData),
      repositoryGroups: JSON.parse(repositoryGroupsData),
      availableBranches: JSON.parse(availableBranchesData),
      selectedBranchesByRepo: JSON.parse(selectedBranchesByRepoData),
      repositoryBranches: JSON.parse(repositoryBranchesData),
      selectedRepositories: JSON.parse(selectedRepositoriesData)
    };
  } catch (error) {
    console.error("Error parsing data:", error);
    return {
      dependencies: [],
      repositories: [],
      repositoryGroups: [],
      availableBranches: [],
      selectedBranchesByRepo: {},
      repositoryBranches: {},
      selectedRepositories: []
    };
  }
}

function createVueApp(mountPoint) {
  const data = getDataFromElement(mountPoint);

  return createApp({
    components: { DependencyTable },
    template: `
      <DependencyTable
        :dependencies="dependencies"
        :repositories="repositories"
        :repositoryGroups="repositoryGroups"
        :availableBranches="availableBranches"
        :selectedBranchesByRepo="selectedBranchesByRepo"
        :repositoryBranches="repositoryBranches"
        :initialSelectedRepositories="selectedRepositories"
      />
    `,
    data() {
      return data;
    }
  });
}

function mountApp(eventName = "initial") {
  if (isMounting) {
    return;
  }

  const mountPoint = document.getElementById("dependency-table-vue-app");
  if (!mountPoint) {
    return;
  }

  isMounting = true;

  try {
    if (app) {
      app.unmount();
    }

    app = createVueApp(mountPoint);
    app.mount(mountPoint);
  } finally {
    isMounting = false;
  }
}

document.addEventListener("turbo:load", () => mountApp("turbo:load"));

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => mountApp("DOMContentLoaded"));
} else {
  mountApp("immediate");
}

document.addEventListener("turbo:submit-end", (event) => {
  if (!event.detail.success) {
    setTimeout(() => {
      document.dispatchEvent(new Event("turbo:load"));
    }, 200);
  }
});
